import PasswordChanged from './PasswordChanged';

export default PasswordChanged;
